import React from "react";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

const NavigateButton = ({
  handleClick,
  dataId,
  name,
  text,
  subText,
  isDisabled,
}) => (
  <Box className="hide-on-print">
    <Button
      variant="contained"
      onClick={() => handleClick()}
      data-id={dataId}
      disabled={isDisabled}
      name={name}
    >
      <span className="buttonText">{text}</span>
      <span className="additionalInfo">{subText}</span>
    </Button>
  </Box>
);

NavigateButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  dataId: PropTypes.string,
  name: PropTypes.string,
  text: PropTypes.string,
  subText: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default NavigateButton;
